import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import ContactForm from "./pages/Contact";
import AboutUs from "./pages/About";
import Career from "./pages/Career";
import Garments from "./SubMenus/Garment";
import FootWears from "./SubMenus/FootWear";
import MenProducts from "./SubMenus/Mens";
import Jackets from "./MensData.js/Jackets";
import Hoodies from "./MensData.js/Hoodies";
import Shirts from "./MensData.js/Shirts";
import Tshirts from "./MensData.js/Tshirts";
import ShortsLower from "./MensData.js/ShortsLower";
import JeansPants from "./MensData.js/JeansPants";
import MenFootwear from "./Footwear.js/MenFootwear";
import WomenFootwear from "./Footwear.js/WomenFootwear";
import MenTshirt1 from "./ProductsDetailsMensTshirt/MensTshirt1";
import MenTshirt2 from "./ProductsDetailsMensTshirt/MensTshirt2";
import MenTshirt3 from "./ProductsDetailsMensTshirt/MensTshirt3";
import MenTshirt4 from "./ProductsDetailsMensTshirt/MensTshirt4";
import MenTshirt5 from "./ProductsDetailsMensTshirt/MensTshirt5";
import MenTshirt6 from "./ProductsDetailsMensTshirt/MensTshirt6";
import Lower1 from "./ProductsDetailsLower/Lower1";
import Lower2 from "./ProductsDetailsLower/Lower2";
import Lower3 from "./ProductsDetailsLower/Lower3";
import Lower4 from "./ProductsDetailsLower/Lower4";
import MenShirt1 from "./ProductsDetailShirt/MenShirt1";
import Jacket1 from "./ProductsDetailsJacket/Jacket1";
import Jacket2 from "./ProductsDetailsJacket/Jacket2";
import Jacket3 from "./ProductsDetailsJacket/Jacket3";
import Jacket4 from "./ProductsDetailsJacket/Jacket4";
import Jacket5 from "./ProductsDetailsJacket/Jacket5";
import Jacket6 from "./ProductsDetailsJacket/Jacket6";
import Jacket7 from "./ProductsDetailsJacket/Jacket7";
import Jacket8 from "./ProductsDetailsJacket/Jacket8";
import Jacket9 from "./ProductsDetailsJacket/Jacket9";
import Jacket10 from "./ProductsDetailsJacket/Jacket10";
import Jacket11 from "./ProductsDetailsJacket/Jacket11";
import Jacket12 from "./ProductsDetailsJacket/Jacket12";
import Jacket13 from "./ProductsDetailsJacket/Jacket13";
import Jacket14 from "./ProductsDetailsJacket/Jacket14";
import Jacket15 from "./ProductsDetailsJacket/Jacket15";
import Jacket16 from "./ProductsDetailsJacket/Jacket16";
import Jacket17 from "./ProductsDetailsJacket/Jacket17";
import Jacket18 from "./ProductsDetailsJacket/Jacket18";
import Jacket19 from "./ProductsDetailsJacket/Jacket19";
import Jeans1 from "./ProductDetailsJeans/Jeans1";
import Lower5 from "./ProductsDetailsLower/Lower5";
import Lower6 from "./ProductsDetailsLower/Lower6";
import FootWear1 from "./WomenFootWearDetails/FootWear1";
import FootWear3 from "./WomenFootWearDetails/FootWear3";
import FootWear2 from "./WomenFootWearDetails/FootWear2";
import FootWear4 from "./WomenFootWearDetails/FootWear4";
import FootWear5 from "./WomenFootWearDetails/FootWear5";
import FootWear6 from "./WomenFootWearDetails/FootWear6";
import MFootWear1 from "./MenFootWearProductsDetail/MFootWear1";
import MFootWear2 from "./MenFootWearProductsDetail/MFootWear2";
import MFootWear3 from "./MenFootWearProductsDetail/MFootWear3";
import MFootWear4 from "./MenFootWearProductsDetail/MFootWear4";
import MFootWear5 from "./MenFootWearProductsDetail/MFootWear5";
import MFootWear6 from "./MenFootWearProductsDetail/MFootWear6";
import MFootWear7 from "./MenFootWearProductsDetail/MFootWear7";
import MFootWear8 from "./MenFootWearProductsDetail/MFootWear8";
import MFootWear9 from "./MenFootWearProductsDetail/MFootWear9";
import MFootWear10 from "./MenFootWearProductsDetail/MFootWear10";
import MFootWear11 from "./MenFootWearProductsDetail/MFootWear11";
import MFootWear12 from "./MenFootWearProductsDetail/MFootWear12";
import MFootWear13 from "./MenFootWearProductsDetail/MFootWear13";
import MFootWear14 from "./MenFootWearProductsDetail/MFootWear14";
import MFootWear15 from "./MenFootWearProductsDetail/MFootWear15";
import MFootWear16 from "./MenFootWearProductsDetail/MFootWear16";
import MFootWear17 from "./MenFootWearProductsDetail/MFootWear17";
import MFootWear18 from "./MenFootWearProductsDetail/MFootWear18";
import MFootWear19 from "./MenFootWearProductsDetail/MFootWear19";
import MFootWear20 from "./MenFootWearProductsDetail/MFootWear20";
import MFootWear21 from "./MenFootWearProductsDetail/MFootWear21";
import MFootWear22 from "./MenFootWearProductsDetail/MFootWear22";
import MFootWear23 from "./MenFootWearProductsDetail/MFootWear23";
import MFootWear24 from "./MenFootWearProductsDetail/MFootWear24";
import MFootWear25 from "./MenFootWearProductsDetail/MFootWear25";
import MFootWear26 from "./MenFootWearProductsDetail/MFootWear26";
import MFootWear27 from "./MenFootWearProductsDetail/MFootWear27";
import MFootWear28 from "./MenFootWearProductsDetail/MFootWear28";
import MFootWear29 from "./MenFootWearProductsDetail/MFootWear29";
import MFootWear30 from "./MenFootWearProductsDetail/MFootWear30";
import MJacket1 from "./JacketProductsDetail/MensJacket1";
import MJacket2 from "./JacketProductsDetail/MensJacket2";
import Hoodie1 from "./HoodieProductsDetails/Hoodie1";
import Hoodie2 from "./HoodieProductsDetails/Hoodie2";
import Hoodie3 from "./HoodieProductsDetails/Hoodie3";
import Hoodie4 from "./HoodieProductsDetails/Hoodie4";
import Hoodie5 from "./HoodieProductsDetails/Hoodie5";
import Hoodie6 from "./HoodieProductsDetails/Hoodie6";
import Hoodie7 from "./HoodieProductsDetails/Hoodie7";
import Hoodie8 from "./HoodieProductsDetails/Hoodie8";
import Hoodie9 from "./HoodieProductsDetails/Hoodie9";
import Hoodie10 from "./HoodieProductsDetails/Hoodie10";
import Hoodie11 from "./HoodieProductsDetails/Hoodie11";
import Hoodie12 from "./HoodieProductsDetails/Hoodie12";
import Hoodie13 from "./HoodieProductsDetails/Hoodie13";
import Hoodie14 from "./HoodieProductsDetails/Hoodie14";
import Hoodie15 from "./HoodieProductsDetails/Hoodie15";
import Hoodie16 from "./HoodieProductsDetails/Hoodie16";
import Hoodie17 from "./HoodieProductsDetails/Hoodie17";
import Hoodie18 from "./HoodieProductsDetails/Hoodie18";
import Hoodie19 from "./HoodieProductsDetails/Hoodie19";
import Hoodie20 from "./HoodieProductsDetails/Hoodie20";
import Hoodie21 from "./HoodieProductsDetails/Hoodie21";
import Hoodie22 from "./HoodieProductsDetails/Hoodie22";
import Hoodie23 from "./HoodieProductsDetails/Hoodie23";
import Hoodie24 from "./HoodieProductsDetails/Hoodie24";
import Hoodie25 from "./HoodieProductsDetails/Hoodie25";
import Hoodie26 from "./HoodieProductsDetails/Hoodie26";
import Hoodie27 from "./HoodieProductsDetails/Hoodie27";
import Hoodie28 from "./HoodieProductsDetails/Hoodie28";
import Hoodie29 from "./HoodieProductsDetails/Hoodie29";
import Hoodie30 from "./HoodieProductsDetails/Hoodie30";
import Hoodie31 from "./HoodieProductsDetails/Hoodie31";
import Hoodie32 from "./HoodieProductsDetails/Hoodie32";
import Hoodie33 from "./HoodieProductsDetails/Hoodie33";
import Hoodie34 from "./HoodieProductsDetails/Hoodie34";
import Hoodie35 from "./HoodieProductsDetails/Hoodie35";
import Hoodie36 from "./HoodieProductsDetails/Hoodie36";
import Hoodie37 from "./HoodieProductsDetails/Hoodie37";
import Hoodie38 from "./HoodieProductsDetails/Hoodie38";
import Hoodie39 from "./HoodieProductsDetails/Hoodie39";
import Hoodie40 from "./HoodieProductsDetails/Hoodie40";
import Hoodie41 from "./HoodieProductsDetails/Hoodie41";
import Hoodie42 from "./HoodieProductsDetails/Hoodie42";
import Hoodie43 from "./HoodieProductsDetails/Hoodie43";
import Hoodie44 from "./HoodieProductsDetails/Hoodie44";
import Hoodie45 from "./HoodieProductsDetails/Hoodie45";
import Hoodie46 from "./HoodieProductsDetails/Hoodie46";
import Hoodie47 from "./HoodieProductsDetails/Hoodie47";
import Hoodie48 from "./HoodieProductsDetails/Hoodie48";
import Hoodie49 from "./HoodieProductsDetails/Hoodie49";
import Hoodie50 from "./HoodieProductsDetails/Hoodie50";
import Hoodie51 from "./HoodieProductsDetails/Hoodie51";
import Hoodie52 from "./HoodieProductsDetails/Hoodie52";
import Hoodie53 from "./HoodieProductsDetails/Hoodie53";
import Hoodie54 from "./HoodieProductsDetails/Hoodie54";
import Hoodie55 from "./HoodieProductsDetails/Hoodie55";
import Hoodie56 from "./HoodieProductsDetails/Hoodie56";
import Hoodie57 from "./HoodieProductsDetails/Hoodie57";
import Hoodie58 from "./HoodieProductsDetails/Hoodie58";
import Hoodie59 from "./HoodieProductsDetails/Hoodie59";
import Hoodie60 from "./HoodieProductsDetails/Hoodie60";
import Hoodie61 from "./HoodieProductsDetails/Hoodie61";
import Hoodie62 from "./HoodieProductsDetails/Hoodie62";
import Hoodie63 from "./HoodieProductsDetails/Hoodie63";
import Events from "./pages/Events";
import LatestCollection from "./components/LatestCollection";

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs/>}/>
        <Route path="/career" element={<Career />} />
        <Route path="/eventspage" element={<Events />} />
        <Route path="/products/garments" element={<Garments />} />
        <Route path="/products/footwear" element={<FootWears />} />
        <Route path="/products/garments/men" element={<MenProducts />} />
        <Route path="/latestcollection" element={<LatestCollection/>} /> 

        <Route path="/contact" element={<ContactForm/>}/>
        <Route path="/products/garments/men/jackets" element={<Jackets/>}/>
        <Route path="/products/garments/men/hoodies" element={<Hoodies/>}/>
        <Route path="/products/garments/men/shirts" element={<Shirts/>}/>
        <Route path="/products/garments/men/tshirts" element={<Tshirts/>}/>
        <Route path="/products/garments/men/shorts" element={<ShortsLower/>}/>
        <Route path="/products/garments/men/jeans" element={<JeansPants/>}/>

        <Route path="/products/footwear/women-footwear" element={<WomenFootwear />} />
        <Route path="/products/footwear/men-footwear" element={<MenFootwear />} />
        {/* Mens Tshirt */}
        <Route path="/products/menstshirt1" element={<MenTshirt1 />} />
        <Route path="/products/menstshirt2" element={<MenTshirt2 />} />
        <Route path="/products/menstshirt3" element={<MenTshirt3 />} />
        <Route path="/products/menstshirt4" element={<MenTshirt4 />} />
        <Route path="/products/menstshirt5" element={<MenTshirt5 />} />
        <Route path="/products/menstshirt6" element={<MenTshirt6 />} />

        {/* Lower & Shorts */}
        <Route path="/products/mens-short&Lowers1" element={<Lower1 />} />
        <Route path="/products/mens-short&Lowers2" element={<Lower2 />} />
        <Route path="/products/mens-short&Lowers3" element={<Lower3 />} />
        <Route path="/products/mens-short&Lowers4" element={<Lower4 />} />
        <Route path="/products/mens-short&Lowers5" element={<Lower5 />} />
        <Route path="/products/mens-short&Lowers6" element={<Lower6 />} />
        {/* Shirt */}
        <Route path="/products/mens-shirt" element={<MenShirt1 />} />

        {/* Hoodie */}
        <Route path="/products/mens-sweat-top&hoodie1" element={<Jacket1 />} />
        <Route path="/products/mens-sweat-top&hoodie2" element={<Jacket2 />} />
        <Route path="/products/mens-sweat-top&hoodie3" element={<Jacket3 />} />
        <Route path="/products/mens-sweat-top&hoodie4" element={<Jacket4 />} />
        <Route path="/products/mens-sweat-top&hoodie5" element={<Jacket5 />} />
        <Route path="/products/mens-sweat-top&hoodie6" element={<Jacket6 />} />
        <Route path="/products/mens-sweat-top&hoodie7" element={<Jacket7 />} />
        <Route path="/products/mens-sweat-top&hoodie8" element={<Jacket8 />} />
        <Route path="/products/mens-sweat-top&hoodie9" element={<Jacket9 />} />
        <Route path="/products/mens-sweat-top&hoodie10" element={<Jacket10 />} />
        <Route path="/products/mens-sweat-top&hoodie11" element={<Jacket11 />} />
        <Route path="/products/mens-sweat-top&hoodie12" element={<Jacket12 />} />
        <Route path="/products/mens-sweat-top&hoodie13" element={<Jacket13 />} />
        <Route path="/products/mens-sweat-top&hoodie14" element={<Jacket14 />} />
        <Route path="/products/mens-sweat-top&hoodie15" element={<Jacket15 />} />
        <Route path="/products/mens-sweat-top&hoodie16" element={<Jacket16 />} />
        <Route path="/products/mens-sweat-top&hoodie17" element={<Jacket17 />} />
        <Route path="/products/mens-sweat-top&hoodie18" element={<Jacket18 />} />
        <Route path="/products/mens-sweat-top&hoodie19" element={<Jacket19 />} />

        {/*   Jeans & pant */}
        <Route path="/products/men-Jeans-&-Pants1" element={<Jeans1/>} />

        {/* Footwear */}
        <Route path="/products/womens-footwear1" element={<FootWear1/>} />
        <Route path="/products/womens-footwear2" element={<FootWear2/>} /> 
        <Route path="/products/womens-footwear3" element={<FootWear3/>} />
        <Route path="/products/womens-footwear4" element={<FootWear4/>} />
        <Route path="/products/womens-footwear5" element={<FootWear5/>} />
        <Route path="/products/womens-footwear6" element={<FootWear6/>} />
        <Route path="/products/mens-footwear1" element={<MFootWear1/>} />
        <Route path="/products/mens-footwear2" element={<MFootWear2/>} />
        <Route path="/products/mens-footwear3" element={<MFootWear3/>} />
        <Route path="/products/mens-footwear4" element={<MFootWear4/>} />
        <Route path="/products/mens-footwear5" element={<MFootWear5/>} />
        <Route path="/products/mens-footwear6" element={<MFootWear6/>} />
        <Route path="/products/mens-footwear7" element={<MFootWear7/>} />
        <Route path="/products/mens-footwear8" element={<MFootWear8/>} />
        <Route path="/products/mens-footwear9" element={<MFootWear9/>} />
        <Route path="/products/mens-footwear10" element={<MFootWear10/>} />
        <Route path="/products/mens-footwear11" element={<MFootWear11/>} />
        <Route path="/products/mens-footwear12" element={<MFootWear12/>} />
        <Route path="/products/mens-footwear13" element={<MFootWear13/>} />
        <Route path="/products/mens-footwear14" element={<MFootWear14/>} />
        <Route path="/products/mens-footwear15" element={<MFootWear15/>} />
        <Route path="/products/mens-footwear16" element={<MFootWear16/>} />
        <Route path="/products/mens-footwear17" element={<MFootWear17/>} />
        <Route path="/products/mens-footwear18" element={<MFootWear18/>} />
        <Route path="/products/mens-footwear19" element={<MFootWear19/>} />
        <Route path="/products/mens-footwear20" element={<MFootWear20/>} />
        <Route path="/products/mens-footwear21" element={<MFootWear21/>} />
        <Route path="/products/mens-footwear22" element={<MFootWear22/>} />
        <Route path="/products/mens-footwear23" element={<MFootWear23/>} />
        <Route path="/products/mens-footwear24" element={<MFootWear24/>} />
        <Route path="/products/mens-footwear25" element={<MFootWear25/>} />
        <Route path="/products/mens-footwear26" element={<MFootWear26/>} />
        <Route path="/products/mens-footwear27" element={<MFootWear27/>} />
        <Route path="/products/mens-footwear28" element={<MFootWear28/>} />
        <Route path="/products/mens-footwear29" element={<MFootWear29/>} />
        <Route path="/products/mens-footwear30" element={<MFootWear30/>} />

        {/* Jackets */}
        <Route path="/products/jackets1" element={<MJacket1/>} />
        <Route path="/products/jackets2" element={<MJacket2/>} />

      {/* Hoodies Continue */}
      <Route path="/products/mens-sweat-top&hoodie20" element={<Hoodie1 />} />
      <Route path="/products/mens-sweat-top&hoodie21" element={<Hoodie2 />} />
      <Route path="/products/mens-sweat-top&hoodie22" element={<Hoodie3 />} />
      <Route path="/products/mens-sweat-top&hoodie23" element={<Hoodie4 />} />
      <Route path="/products/mens-sweat-top&hoodie24" element={<Hoodie5 />} />
      <Route path="/products/mens-sweat-top&hoodie25" element={<Hoodie6 />} />
      <Route path="/products/mens-sweat-top&hoodie26" element={<Hoodie7 />} />
      <Route path="/products/mens-sweat-top&hoodie27" element={<Hoodie8 />} />
      <Route path="/products/mens-sweat-top&hoodie28" element={<Hoodie9 />} />
      <Route path="/products/mens-sweat-top&hoodie29" element={<Hoodie10 />} />
      <Route path="/products/mens-sweat-top&hoodie30" element={<Hoodie11 />} />
      <Route path="/products/mens-sweat-top&hoodie31" element={<Hoodie12 />} />
      <Route path="/products/mens-sweat-top&hoodie32" element={<Hoodie13 />} />
      <Route path="/products/mens-sweat-top&hoodie33" element={<Hoodie14 />} />
      <Route path="/products/mens-sweat-top&hoodie34" element={<Hoodie15 />} />
      <Route path="/products/mens-sweat-top&hoodie35" element={<Hoodie16 />} />
      <Route path="/products/mens-sweat-top&hoodie36" element={<Hoodie17 />} />
      <Route path="/products/mens-sweat-top&hoodie37" element={<Hoodie18 />} />
      <Route path="/products/mens-sweat-top&hoodie38" element={<Hoodie19 />} />
      <Route path="/products/mens-sweat-top&hoodie39" element={<Hoodie20 />} />
      <Route path="/products/mens-sweat-top&hoodie40" element={<Hoodie21 />} />
      <Route path="/products/mens-sweat-top&hoodie41" element={<Hoodie22 />} />
      <Route path="/products/mens-sweat-top&hoodie42" element={<Hoodie23 />} />
      <Route path="/products/mens-sweat-top&hoodie43" element={<Hoodie24 />} />
      <Route path="/products/mens-sweat-top&hoodie44" element={<Hoodie25 />} />
      <Route path="/products/mens-sweat-top&hoodie45" element={<Hoodie26 />} />
      <Route path="/products/mens-sweat-top&hoodie46" element={<Hoodie27 />} />
      <Route path="/products/mens-sweat-top&hoodie47" element={<Hoodie28 />} />
      <Route path="/products/mens-sweat-top&hoodie48" element={<Hoodie29 />} />
      <Route path="/products/mens-sweat-top&hoodie49" element={<Hoodie30 />} />
      <Route path="/products/mens-sweat-top&hoodie50" element={<Hoodie31 />} />
      <Route path="/products/mens-sweat-top&hoodie51" element={<Hoodie32 />} />
      <Route path="/products/mens-sweat-top&hoodie52" element={<Hoodie33 />} />
      <Route path="/products/mens-sweat-top&hoodie53" element={<Hoodie34 />} />
      <Route path="/products/mens-sweat-top&hoodie54" element={<Hoodie35 />} />
      <Route path="/products/mens-sweat-top&hoodie55" element={<Hoodie36 />} />
      <Route path="/products/mens-sweat-top&hoodie56" element={<Hoodie37 />} />
      <Route path="/products/mens-sweat-top&hoodie57" element={<Hoodie38 />} />
      <Route path="/products/mens-sweat-top&hoodie58" element={<Hoodie39 />} />
      <Route path="/products/mens-sweat-top&hoodie59" element={<Hoodie40 />} />
      <Route path="/products/mens-sweat-top&hoodie60" element={<Hoodie41 />} />
      <Route path="/products/mens-sweat-top&hoodie61" element={<Hoodie42 />} />
      <Route path="/products/mens-sweat-top&hoodie62" element={<Hoodie43 />} />
      <Route path="/products/mens-sweat-top&hoodie63" element={<Hoodie44 />} />
      <Route path="/products/mens-sweat-top&hoodie64" element={<Hoodie45 />} />
      <Route path="/products/mens-sweat-top&hoodie65" element={<Hoodie46 />} />
      <Route path="/products/mens-sweat-top&hoodie66" element={<Hoodie47 />} />
      <Route path="/products/mens-sweat-top&hoodie67" element={<Hoodie48 />} />
      <Route path="/products/mens-sweat-top&hoodie68" element={<Hoodie49 />} />
      <Route path="/products/mens-sweat-top&hoodie69" element={<Hoodie50 />} />
      <Route path="/products/mens-sweat-top&hoodie70" element={<Hoodie51 />} />
      <Route path="/products/mens-sweat-top&hoodie71" element={<Hoodie52 />} />
      <Route path="/products/mens-sweat-top&hoodie72" element={<Hoodie53 />} />
      <Route path="/products/mens-sweat-top&hoodie73" element={<Hoodie54 />} />
      <Route path="/products/mens-sweat-top&hoodie74" element={<Hoodie55 />} />
      <Route path="/products/mens-sweat-top&hoodie75" element={<Hoodie56 />} />
      <Route path="/products/mens-sweat-top&hoodie76" element={<Hoodie57 />} />
      <Route path="/products/mens-sweat-top&hoodie77" element={<Hoodie58 />} />
      <Route path="/products/mens-sweat-top&hoodie78" element={<Hoodie59 />} />
      <Route path="/products/mens-sweat-top&hoodie79" element={<Hoodie60 />} />
      <Route path="/products/mens-sweat-top&hoodie80" element={<Hoodie61 />} />
      <Route path="/products/mens-sweat-top&hoodie81" element={<Hoodie62 />} />
      <Route path="/products/mens-sweat-top&hoodie82" element={<Hoodie63 />} />

      </Routes>
      <Footer/>
    </Router>
  );
}
